export interface IPatientGap {
  id: number;
  measure_code: string;
  member_name: string;
  measure_description: string;
  app: boolean;
  treated_provider_id: number;
  treated_provider_name: string;
  complete: boolean;
  ehr: boolean;
  claim: boolean;
}

export interface IResultPatientGap {
  count: number;
  next: string | null;
  previous: string | null;
  results: IPatientGap[];
}

export class PatientGap {
  id: number;
  measureCode: string;
  memberName: string;
  measureDescription: string;
  app: boolean;
  treatedProviderId: number;
  treatedProviderName: string;
  complete: boolean;
  ehr: boolean;
  claim: boolean;

  constructor(gap: IPatientGap) {
    this.id = gap.id;
    this.measureCode = gap.measure_code;
    this.memberName = gap.member_name;
    this.measureDescription = gap.measure_description;
    this.app = gap.app;
    this.treatedProviderId = gap.treated_provider_id;
    this.treatedProviderName = gap.treated_provider_name;
    this.complete = gap.complete;
    this.ehr = gap.ehr;
    this.claim = gap.claim;
  }

  static fromObject(gap: IPatientGap): PatientGap {
    return new PatientGap(gap);
  }

  static fromObjectArray(gaps: IPatientGap[]): PatientGap[] {
    return gaps.map(gap => new PatientGap(gap));
  }
}

export class PatientGapResult {
  count: number;
  next: string | null;
  previous: string | null;
  results: PatientGap[];

  constructor(result?: IResultPatientGap) {
    this.count = result?.count ?? 0;
    this.next = result?.next ?? null;
    this.previous = result?.previous ?? null;
    this.results = result ? PatientGap.fromObjectArray(result.results) : [];
  }

  static fromObject(result: IResultPatientGap): PatientGapResult {
    return new PatientGapResult(result);
  }
}
